module.exports = __webpack_public_path__ + "static/media/chevron-up.2402ab34.svg";